import React from 'react';

import storyStepper from 'src/assets/starterDashboardV2/readyToShare/storyStepper.svg';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { HeaderStyles, RectangleShapeStyles, SkeletonContainerStyles, StoryStepperStyles } from './Header.styles';
import type { FacebookStoryComponentsProps } from './types';

export function Header(props: FacebookStoryComponentsProps): React.JSX.Element | null {
	const { size, loading, retryState } = props;

	if (size === 'xsmall' && loading) {
		return null;
	}

	// Disable animation when in failed retry state (static background for better contrast)
	const shouldAnimate = loading && retryState !== 'failed';

	const styles = HeaderStyles({ size });
	const rectangleStyles = RectangleShapeStyles({ size });

	return (
		<div className={styles}>
			<img className={StoryStepperStyles({ size })} src={storyStepper} alt="" aria-hidden />
			<SkeletonContainer
				className={SkeletonContainerStyles({ size })}
				shapeColorClassName="bg-icon-weak"
				shapeSize={size}
				loading={shouldAnimate}
			>
				<Circle />
				<Rectangle className={rectangleStyles} rounded />
			</SkeletonContainer>
		</div>
	);
}
